import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-agreement',
  templateUrl: './agreement.component.html'
})
export class AgreementComponent implements OnInit {
  @Input() input: any;
  @Input() group: FormGroup;
  constructor() { }

  ngOnInit() {
  }

}
